// extracted by mini-css-extract-plugin
export var brand = "_9c-9";
export var compact = "_9c-6";
export var extraSmall = "_9c-7";
export var icon = "_9c-0";
export var large = "_9c-4";
export var light = "_9c-1";
export var medium = "_9c-5";
export var outline = "_9c-b";
export var primaryDark = "_9c-a";
export var primaryLight = "_9c-8";
export var primaryModern = "_9c-c";
export var success = "_9c-2";
export var successSolid = "_9c-3";